export default class HeaderState {
    constructor($el) {
        this.$el = $el;
        this.$pageHeader = document.querySelector('[data-page-header]');
        this.updateHeaderState = this.updateHeaderState.bind(this);

        window.addEventListener('scroll', this.updateHeaderState, {passive: true});
        window.addEventListener('resize', this.updateHeaderState, {passive: true});
        this.updateHeaderState();
    }

    updateHeaderState() {
        const isDesktop = window.matchMedia('(min-width: 1200px)').matches;
        let isSolid = !this.$pageHeader;

        if (isDesktop && this.$pageHeader) {
            const triggerY = this.$pageHeader.offsetHeight - this.$el.offsetHeight;
            isSolid = window.scrollY > Math.max(triggerY, 0);
        }

        this.$el.classList.toggle('header--solid', !isDesktop || isSolid);
    }
}
